import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  
  dashboard: {
    background : '#F7F3F8',
    color: '#1A0244',
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    margin: '0',
    padding: '0',
    width: '100vw',
},
left_container: {
    height: '100vh',
    margin: '0',
    padding: '0',
    
},
right_container:{
    height: '100vh',
    margin: '0',
    padding: "20px 40px",
    overflowY: 'auto',
    overflowX: 'hidden'
},
}));
